export enum ActiveStatus {
  Active = "Active",
  InActive = "Inactive"
}
